module.exports = __webpack_public_path__ + "static/media/pausa-errada.a9b49c81.png";